export default __webpack_public_path__ + "static/media/bajucowo.852dc5bd.jpeg";